import React from 'react'

const ButtonComponent = ({ text }) => {
  return (
    <div className='button-rounded--outline '>{text}</div>
  )
}

export default ButtonComponent